import { USUARIO_LOGOUT, GET_USUARIO } from "../actions.type";
import {
  START_USUARIO_LOGOUT,
  END_USUARIO_LOGOUT,
  UPDATE_USUARIO_LOGOUT,
  START_USUARIO_LOGIN,
  END_USUARIO_LOGIN,
  UPDATE_USUARIO_LOGIN
} from "../mutations.type";
import UsuarioService from "../../services/usuario.service";
import { clearAuthState } from "../../utils/Autenticacao";

const INITIAL_STATE = {
  logado: false, // Alterado de null para false
  usuarioLogado: null
};

export const state = Object.assign({}, INITIAL_STATE);

export const getters = {
  logado: state => state.logado, // Getter como função
  usuarioLogado: state => state.usuarioLogado // Getter como função
};

export const actions = {
  [USUARIO_LOGOUT]: ({ commit }) => {
    commit(START_USUARIO_LOGOUT, null, { root: true });
    clearAuthState();
    commit(UPDATE_USUARIO_LOGOUT, null, { root: true });
    return Promise.resolve();
  },

  [GET_USUARIO]: ({ commit }, state) => {
    commit(START_USUARIO_LOGIN, null, { root: true });
    return UsuarioService.getUsuario()
      .then(({ data }) => {
        commit(UPDATE_USUARIO_LOGIN, data, { root: true });
        localStorage.setItem("login", data.login);
        localStorage.setItem("pessoa", JSON.stringify(data.pessoa));
        return data;
      })
      .catch(() => {
        commit(END_USUARIO_LOGIN, null, { root: true });
      });
  }
};

export const mutations = {
  [START_USUARIO_LOGOUT]: state => (state.logado = true),

  [END_USUARIO_LOGOUT]: state => (
    (state.usuarioLogado = null), (state.logado = false)
  ),

  [UPDATE_USUARIO_LOGOUT]: state => (
    (state.usuarioLogado = null), (state.logado = false)
  ),

  [START_USUARIO_LOGIN]: state => (
    (state.usuarioLogado = null), (state.logado = false)
  ),

  [END_USUARIO_LOGIN]: state => (
    (state.usuarioLogado = null), (state.logado = false)
  ),

  [UPDATE_USUARIO_LOGIN]: (state, data) => (
    (state.usuarioLogado = data), (state.logado = true)
  )
};

export default {
  state,
  getters,
  actions,
  mutations
};
